import React, { useEffect } from "react";
import { Avatar, Card } from "antd";
import { connect } from "react-redux";
import { getEmployeeRewardList } from "../../../../../redux/employeereward/employeeRewardState";
import dayjs from "dayjs";

const ActivitiesCard = ({
  recordList,
  pagination,
  doSearch
}) => {

  useEffect(() => {
    doSearch({ paginate: pagination?.per_page });
  }, [doSearch, pagination?.per_page]);

  return (
    <div className="flex flex-col gap-3">
      {recordList?.map((item) => (
        <Card
          key={item?.erw_id}
          className="rounded-xl dark-mode-card"
        >
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <Avatar
                size={40}
                className="bg-gradient-to-br from-emerald-500 to-violet-500 overflow-hidden"
              >
                {item?.employee_name
                  ?.split(" ")
                  .map(n => n[0])
                  .join("")}
              </Avatar>

              <div className="flex-1 min-w-0">
                <p className="font-medium text-[13px] title-text truncate">
                  {item?.employee_name}
                </p>

                <p className="text-[11px] text-muted-foreground muted-text line-clamp-1">
                  {item?.reward_title}: {item?.erw_reason}
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-end shrink-0">
              <span className="rounded-xl border px-2 py-0.5 gradient emerald  text-white text-[11px] font-semibold">
                +{item?.erw_points_awarded} credits
              </span>

              <p className="text-[10px] text-muted-foreground muted-text mt-1">
                {item?.erw_issued_at
                  ? dayjs(item.erw_issued_at).format("YYYY-MM-DD")
                  : ""}
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeReward.employeeRewardList?.items,
  pagination: state.employeeReward.employeeRewardList?.pagination,
  filters: state.employeeReward.employeeRewardList?.filters,
  requesting: state.employeeReward.employeeRewardList?.requesting,
  error: state.employeeReward.employeeRewardList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeRewardList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesCard);